import "core-js/modules/es.string.link";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Link from "../../../../Common/Link";
import { Heading, Text } from "../../../../Typography";
import styles from './ServiceLink.scss';

var ServiceLink = function ServiceLink(_ref) {
  var item = _ref.item,
      url = _ref.url,
      isActive = _ref.isActive;

  var _useTranslation = useTranslation(['headerUi']),
      t = _useTranslation.t;

  var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: 2,
    className: classnames(styles.heading, _defineProperty({}, styles.active, isActive))
  }, item), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "label"
  }, t("".concat(item.toUpperCase(), "_TEXT"))));

  if (isActive) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.link
    }, content);
  }

  return /*#__PURE__*/React.createElement(Link, {
    to: url,
    className: styles.link
  }, content);
};

export default ServiceLink;